import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FiLogOut } from 'react-icons/fi';
import { useAuth } from '@/features/auth/contexts/AuthContext';
import './styles.css';

export interface PublicLayoutProps {
  children: React.ReactNode;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation(); // Get current location

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const showLogoutButton = isAuthenticated && location.pathname !== '/login';

  return (
    <div className="public-layout">
      <header className="public-layout-header">
        <div className="public-layout-header-grid">
          <Link to="/" className="header-title-link">
            <h1 className="header-title">STS AI Eval</h1>
          </Link>
          <div className="header-col-2">
            {showLogoutButton && (
              <button className="logout-button" onClick={handleLogout} title="Logout">
                <FiLogOut />
                <span>Logout</span>
              </button>
            )}
          </div>
        </div>
      </header>
      <main className="public-layout-main">
        <div className="public-layout-content">
          {children}
        </div>
      </main>
    </div>
  );
};

export default PublicLayout;
